import React from 'react'

function SearchMessages() {

    function handleBack() {
        document.querySelector(".Searchmessages").classList.remove("translateLeft");
    }

    return (
        <div className='Searchmessages'>
            <section className='homesection '>
                <i onClick={handleBack} style={{ color: "white", fontSize: "1.25rem", padding: "1rem", cursor: "pointer" }} class="fa-solid fa-xmark"></i>
                <p style={{ fontWeight: "600", marginRight: "45%" }}>Search Messages</p>
            </section>
            <div className="myProfileBody">
                <input style={{ display: "block", margin: "2rem auto" }} className='homenavinput' type="search" name="" id="search_input" placeholder='Search Chat' />
            </div>
        </div>
    )
}

export default SearchMessages